import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CreateStaticFileGroupingExportFileSpecCommand extends ValueObject {

    public staticServiceProviderFileGroupingId: number = 0;

    public staticExportFileSpecId: number = 0;

    public isExcluded: boolean = false;
}